import { IDevice } from "@formant/core/model/IDevice";
import { IVideoDevice } from "@formant/core/model/IVideoDevice";

export function videoUsbDevicesForDevices(
    devices: IDevice[] | undefined,
): IVideoDevice[] {
    return (
        (devices &&
            devices
                .reduce<IVideoDevice[]>(
                    (acc, _) => [
                        ...acc,
                        ...(_.state?.hwInfo?.videoDevices || []),
                    ],
                    [],
                )
                .sort((a, b) => a.name.localeCompare(b.name))
                .filter(
                    (_, index, array) =>
                        array.findIndex(e => e.path === _.path) === index,
                )) ||
        []
    );
}
